import TableSelectColumnConfig from "./TableSelectColumnConfig";
import TableSelectRow from "./TableSelectRow";

export default class TableSelectConfig {
    public columns: TableSelectColumnConfig[] = [];
    public rows: TableSelectRow[] = [];
}